/**
 * Created by pajicv on 10/1/18.
 */
import React from 'react';
import { Card, CardContent, Typography, CardActions, Button, Badge, Tooltip } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import CoManagerIcon from '@material-ui/icons/People';
import WorkerIcon from '@material-ui/icons/Person';
import Icon from '@material-ui/core/Icon';
import CyclesIcon from '@material-ui/icons/Refresh';
import TaskIcon from '@material-ui/icons/Build';
import TimeIcon from '@material-ui/icons/WatchLater';
import SvgIcon from '@material-ui/core/SvgIcon';
import { MANAGER_ROLE, CO_MANAGER_ROLE, WORKER_ROLE } from '../../utils/constants';
import { getNumberOfActiveTasksInProject, getTasks } from '../../firebase/db';
import { getNumberOfMyOpenTasksOnProject, getNumberOfMyOpenTasksOnProject_v2 } from '../../firebase/db/project';
import { Base64 } from 'js-base64';

class ProjectCard extends React.Component {

    state = {
        numberOfCycles: null,
        numberOfTasks: null
    };

    componentDidMount() {
        const { projectId, auth } = this.props;
        if (this.props.role !== 'worker') {
            getNumberOfActiveTasksInProject(projectId)
                .then((numberOfTasks) => this.setState({ numberOfTasks }, () => console.log(this.state)));
        } else {
            getNumberOfMyOpenTasksOnProject_v2(projectId, auth.email)
                .then((numberOfTasks) => {
                    console.log(numberOfTasks);
                    this.setState({ numberOfTasks }, () => console.log(this.state));
                });
        }
    }

    render() {
        const { title, projectId, createdBy, createdOn, startDate, endDate, members, isSetupCompleted, role, onContinueSetupClick, onDeleteProject, onWorkerViewTasks, auth, projectCycles, onCreateUXCycleClick } = this.props;

        const numberOfCycles = (projectCycles && projectCycles.cycles) ? Object.keys(projectCycles.cycles).length : 0;
        const { numberOfTasks } = this.state;

        const projectRole = members && members[Base64.encode(auth.email)] || {};
        if (role === WORKER_ROLE && projectRole === MANAGER_ROLE && numberOfTasks === 0) return null;

        const renderMembers = () => {
            const managers = [];
            const workers = [];
            const coManagers = [];
            Object.keys(members || {}).forEach((memberKey) => {
                if (memberKey) {
                    switch (members[memberKey]) {
                        case MANAGER_ROLE: {
                            managers.push(window.atob(memberKey));
                            break;
                        }
                        case CO_MANAGER_ROLE: {
                            coManagers.push(window.atob(memberKey));
                            break;
                        }
                        case WORKER_ROLE: {
                            workers.push(window.atob(memberKey));
                            break;
                        }
                        default: {
                        }
                    }
                }
            });

            const managersTooltip = managers.map((m, i) => {
                if (i !== 0) {
                    return m + ' '
                }
            })

            const workersTooltip = workers.map((w, i) => {
                if (i !== 0) {
                    return w + ' '
                }
            })

            const coManagersTooltip = coManagers.map((cm, i) => {
                if (i !== 0) {
                    return cm + ' '
                }
            })

            return (
                <React.Fragment>
                    <div style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}
                    >
                        <div style={{
                            display: 'flex',
                            alignItems: 'center'
                        }}
                        >
                            {/* <Icon
                                className={`fa fa-user-tie`}
                                fontSize="small"
                            /> */}
                            <img src={require('../../icon-manager.svg')} height="20" width="20" alt="Manager" />
                            <Typography style={{ marginLeft: 10 }}>
                                {managers[0]}
                            </Typography>
                        </div>
                        {(managers.length > 1)
                            && (
                                <Tooltip title={managersTooltip}>
                                    <Badge badgeContent={`+${managers.length - 1}`} color="primary" style={{ zIndex: '1' }}>
                                        <Typography>
                                            {}
                                        </Typography>
                                    </Badge>
                                </Tooltip>
                            )
                        }
                    </div>
                    <div style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}
                    >
                        <div style={{
                            display: 'flex',
                            alignItems: 'center'
                        }}
                        >
                            <WorkerIcon />
                            <Typography style={{ marginLeft: 10 }}>
                                {(workers.length > 0) ? workers[0] : ' '}
                            </Typography>
                        </div>
                        {(workers.length > 1)
                            && (
                                <Tooltip title={workersTooltip}>
                                    <Badge badgeContent={`+${workers.length - 1}`} color="primary" style={{ zIndex: '1' }}>
                                        <Typography>
                                            {}
                                        </Typography>
                                    </Badge>
                                </Tooltip>
                            )
                        }
                    </div>
                    <div style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}
                    >
                        <div style={{
                            display: 'flex',
                            alignItems: 'center'
                        }}
                        >
                            <CoManagerIcon />
                            <Typography style={{ marginLeft: 10 }}>
                                {(coManagers.length > 0) ? coManagers[0] : ' '}
                            </Typography>
                        </div>
                        {(coManagers.length > 1)
                            && (
                                <Tooltip title={coManagersTooltip}>
                                    <Badge badgeContent={`+${coManagers.length - 1}`} color="primary" style={{ zIndex: '1' }}>
                                        <Typography>
                                            {}
                                        </Typography>
                                    </Badge>
                                </Tooltip>

                            )
                        }
                    </div>
                </React.Fragment>
            );
        };

        const renderButtons = () => {
            switch (role) {
                case MANAGER_ROLE: {
                    if (!isSetupCompleted) {
                        return (
                            <React.Fragment>
                                <Button size="small" color="primary" onClick={onContinueSetupClick}>
                                    Setup
                            </Button>
                                {
                                    createdBy && (window.atob(createdBy) === auth.email)
                                    && (
                                        <Button
                                            color="primary"
                                            onClick={onDeleteProject}
                                        >
                                            <DeleteIcon fontSize="small" />
                                        </Button>
                                    )
                                }
                            </React.Fragment>
                        );
                    }
                    return (
                        <React.Fragment>
                            <Button size="small" color="primary" onClick={onContinueSetupClick}>
                                Setup
                            </Button>
                            <Button size="small" color="primary" onClick={() => onCreateUXCycleClick(projectId)}>
                                CX Cycles
                            </Button>
                            {createdBy && (window.atob(createdBy) === auth.email)
                                && (
                                    <Button
                                        color="primary"
                                        onClick={onDeleteProject}
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </Button>
                                )
                            }
                        </React.Fragment>
                    );
                }
                case WORKER_ROLE: {
                    if (!isSetupCompleted) {
                        return (
                            <Typography color="secondary">SETUP FORTFÜHREN</Typography>
                        );
                    }
                    return (
                        <Button size="small" color="primary" onClick={onWorkerViewTasks}>
                            Tasks
                        </Button>
                    );
                }
                case CO_MANAGER_ROLE: {
                    if (!isSetupCompleted) {
                        return (
                            <Typography color="secondary">SETUP FORTFÜHREN</Typography>
                        );
                    }
                    return (
                        <Button size="small" color="primary" onClick={() => onCreateUXCycleClick(projectId)}>
                            CX Cycles
                        </Button>
                    );
                }
                default: { }
            }
        };

        return (<Card style={{
            margin: 20,
            width: 300,
            height: 300,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            alignContent: 'flex-start'
        }}
        >
            <CardContent style={{ height: 80 }}>
                <Typography gutterBottom variant="headline" component="h2">
                    {title}
                </Typography>
            </CardContent>
            <CardContent style={{ witdh: 290 }}>
                <div style={{
                    width: 250,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}
                >
                    <div style={{
                        display: 'flex',
                        alignItems: 'center'
                    }}
                    >
                        <TimeIcon />
                        <Typography style={{ marginLeft: 10 }}>
                            {startDate ? (new Date(startDate)).toLocaleDateString('de-AT') : ''}
                        </Typography>
                    </div>
                </div>
                {renderMembers()}
                <div style={{
                    width: 250,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}
                >
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer'
                    }}
                    >
                        <img src={require('../../icons/cycle.svg')} height="20" width="20" alt="Cycles" onClick={(role === MANAGER_ROLE || projectRole === MANAGER_ROLE) && (() => onCreateUXCycleClick(projectId))} />
                        <Typography style={{ marginLeft: 10 }}>
                            {numberOfCycles}
                        </Typography>
                    </div>
                </div>
                <div style={{
                    width: 250,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}
                >
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer'
                    }}
                    >
                        <img src={require('../../icons/gear.svg')} height="20" width="20" alt="Tasks" onClick={(role === WORKER_ROLE || role === MANAGER_ROLE) ? onWorkerViewTasks : (() => console.log('tasks'))} />
                        <Typography style={{ marginLeft: 10 }}>
                            {numberOfTasks}
                        </Typography>
                    </div>
                </div>
            </CardContent>
            <CardActions style={{ height: 60 }}>
                {renderButtons()}
            </CardActions>
        </Card>

        );
    }
}

export default ProjectCard;



// WEBPACK FOOTER //
// ./src/components/common/ProjectCard.js